var exports = {
  "ZK": "ChannelFollowSuccessModal.module__hero___TVZsbn",
  "Wp": "ChannelFollowSuccessModal.module__patternImage___TVZsbn",
  "RG": "ChannelFollowSuccessModal.module__composition___TVZsbn",
  "Dr": "ChannelFollowSuccessModal.module__sourceIconWrap___TVZsbn",
  "$f": "ChannelFollowSuccessModal.module__guildIcon___TVZsbn",
  "hI": "ChannelFollowSuccessModal.module__announcementBadge___TVZsbn",
  "aw": "ChannelFollowSuccessModal.module__announcementBadgeIcon___TVZsbn",
  "UE": "ChannelFollowSuccessModal.module__arrow___TVZsbn",
  "rf": "ChannelFollowSuccessModal.module__body___TVZsbn",
  "DD": "ChannelFollowSuccessModal.module__title___TVZsbn",
  "h_": "ChannelFollowSuccessModal.module__description___TVZsbn",
};

module.exports = exports;
